import * as React from "react";
import { Document, DocUploadArgs } from "../../types/Document";
import { AccountForm } from "../NotifierForm/AccountForm";
import { UpdateExpressFormTemplateProc } from "@/templates/ExpressFormTemplate";
import { identity } from "lodash";
import { ExpressFormMenuKey, ExpressStoreKey, useExpressSectionDataByKey } from "./express-data";
import { ServiceProvider } from "@/types/index";
import { ExpressUiInfoContext } from "@/store/ExpressUiInfo";
import { dealWithQuilter } from "@/helpers/account-helpers";
import { createExpressDocument } from "@/services/api/document-api";

export type AccountDetailsProps = {
  readonly serviceProvider: ServiceProvider;
  readonly next: () => void;
  readonly uploadedFileInfo: (id: string) => Promise<Document>;
  readonly onSectionClick: (section: string) => void;
  readonly updateTemplate: UpdateExpressFormTemplateProc;
};
const CURRENT_SECTION_STORAGE_KEY = ExpressStoreKey.SingleAccount;
const FORM_STEP_CURRENT_SECTION = ExpressFormMenuKey.Account;

export const AccountDetails: React.FunctionComponent<AccountDetailsProps> = ({
  serviceProvider,
  next,
  uploadedFileInfo,
  updateTemplate,
  onSectionClick,
}) => {
  const { data, loaded, saveData } = useExpressSectionDataByKey(CURRENT_SECTION_STORAGE_KEY);
  const {
    state: { quilter },
    dispatch,
  } = React.useContext(ExpressUiInfoContext);

  const updateTemplateDelegate = React.useCallback(
    ({ onNext }) => {
      updateTemplate({
        busy: false,
        currentSection: FORM_STEP_CURRENT_SECTION,
        nextLabel: "Next",
        saveLabel: null,
        onNext: () => {
          onNext();
        },
        onSectionClick,
      });
    },
    [onSectionClick, updateTemplate]
  );

  const saveRecord = React.useCallback(
    (data: any) => {
      saveData(data);
      if (data.target) {
        dealWithQuilter(quilter.isQuilter, data.target, dispatch);
        next();
      }
    },
    [next, saveData]
  );

  if (!loaded) return null;
  return (
    <AccountForm
      caseId={""} // TODO: remove
      signature={""} // TODO: remove
      serviceProvider={{ id: "id", ...serviceProvider }}
      serviceProviders={[]}
      properties={[]}
      // @ts-ignore
      persons={[{ id: "notifier", title: "", firstName: "Myself", lastName: "" }]}
      setBusy={identity}
      onAccountUpdated={identity} // TODO
      uploadedFileInfo={uploadedFileInfo}
      createDocument={createExpressDocument}
      updateTemplate={updateTemplateDelegate}
      savedRecord={data}
      saveRecord={saveRecord}
    />
  );
};
